<template>
  <title-slot :title="servicesTitle"
              :type-title="'big'">
    <autocomplete-multiple :items="servicesComputed"
                           :info-select="infoSelect"
                           :value="servicesOut"
                           @changeValue="value => $emit('changeService', value.value)"
    />

    <div class="services-container" v-if="servicesOut.length > 0">
      <label-custom v-for="item in servicesOut"
                    @closeLabel="$emit('closeService', item)"
                    :label-text="item"/>
    </div>
  </title-slot>
</template>

<script>
import TitleSlot from "@/components/entities/TitleSlot.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import AutocompleteMultiple from "@/components/shared/AutocompleteMultiple.vue";
import {mapState} from "vuex";
import LabelCustom from "@/components/shared/LabelCustom.vue";

export default {
  name: "ServicesBlock",
  components: {LabelCustom, AutocompleteMultiple, InputMain, TitleSlot},
  props: {
    servicesTitle: {
      type: String,
      default: 'Связанные услуги'
    },
    servicesOut: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      infoSelect: {
        key: 'select',
        placeholder: 'Начните вводить название услуги'
      }
    }
  },
  computed: {
    ...mapState('services', ['relatedServices']),
    servicesComputed() {
      return this.relatedServices.map(item => ({
        id: item.id,
        title: item.value,
        value: item.value
      }))
    }
  }
}
</script>

<style scoped lang="scss">
.title-slot-container {
  row-gap: 32px;
  .services-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;

  }
}
</style>